import { size } from "polished";
import { useEffect } from "react";
import { gtmPush } from "shared-utils/src/gtm";
import styled from "styled-components";
import CalendarIcon from "../img/icons/calendar.svg?react";
import { renderSyncDisplay } from "../utils/ecal-sync-display-spa";
import Button from "./Button";

const BannerButton = styled.button`
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;

  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
`;

const StyledButton = styled(Button)`
  padding: 0.6rem 1.2rem;
  border-radius: ${({ theme }) => theme.radii[4]};
  font-size: ${({ theme }) => theme.fontSizes[0]};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  text-align: center;
  line-height: 1;
`;

const StyledCalendarIcon = styled(CalendarIcon)`
  ${size(20, "auto")};
`;

type IEcalButtonProps = React.ComponentPropsWithoutRef<"button"> & {
  variant: "styled" | "unstyled";
  gtmClass: string;
  children: React.ReactNode;
};

const EcalButton = ({
  variant = "styled",
  gtmClass,
  children,
}: IEcalButtonProps) => {
  const ecalAPIKey = import.meta.env.VITE_ECAL_API_KEY;

  const handleOnClick = (gtmClass: string) => {
    const gtmElement = gtmClass === "banner" ? "img" : "button";
    gtmPush({
      event: "eCal CTA",
      "gtm.element": `${gtmElement}`,
      "gtm.elementClasses": `eCal CTA ${gtmClass}`,
    });
  };

  const getSharedAttributes = (gtmClass: string) => ({
    className: `ecal-sync-widget-button eCal CTA ${gtmClass}`,
    "data-ecal-category": "Fixture/{{ECAL_USER_COUNTRYCODE}}",
    "data-ecal-widget-id": "688ac1a82d6fea00087a26b0",
    "data-ecal-no-styling": true,
    onClick: () => handleOnClick(gtmClass),
  });

  const sharedAttributes = getSharedAttributes(gtmClass);

  useEffect(() => {
    renderSyncDisplay(ecalAPIKey);
  }, []);

  if (variant === "unstyled") {
    return <BannerButton {...sharedAttributes}>{children}</BannerButton>;
  }
  return (
    <StyledButton {...sharedAttributes}>
      <StyledCalendarIcon />
      {children}
    </StyledButton>
  );
};

export default EcalButton;
